/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../../sharedComponents/Link";
// eslint-disable-next-line import/no-cycle
import { Icon } from "../../Icons";
import * as styles from "./NoBorderCard.module.scss";

const CardTabTheme = {
	"#FB344D": "pink",
	"#00A887": "turquoise",
	"#00A2AD": "beach",
	"#FF6000": "sun",
}; // These are the one from https://app.contentful.com/spaces/h82kzjd39wa1/environments/master/content_types/linkTile/fields

export function mapColorToTheme(color) {
	return CardTabTheme[color];
}

const NoBorderCard = ({
	image,
	header,
	button,
	subheader,
	color,
	link,
	className,
	hideLinks,
	ribbon,
}) => (
	<Card className={cx(styles.noBorder, className)}>
		<div className={styles.noBorderImageWrapper}>
			<Card.Image
				className={cx(styles.noBorderImage, className?.noBorderImage)}
				src={!image.srcSet && image.src}
				source={image.srcSet && image}
				alt={image.alt}
				fluid={image.fluid}
			/>
			{!!ribbon && (
				<span className={styles.ribbon}>
					<span className={styles.ribbonContent}>#{ribbon}</span>
				</span>
			)}
			{subheader && (
				<div
					className={styles.noBorderTab}
					style={{ "--_tab-color": `var(--color-${mapColorToTheme(color)})` }}>
					{subheader}
				</div>
			)}
		</div>
		<div className={styles.noBorderContainer}>
			<Card.Header className={styles.noBorderHeading}>{header}</Card.Header>
			{!hideLinks && (
				<div>
					{(button?.to || link?.to) && (
						<Link
							to={button?.to || link?.to}
							className={styles.noBorderTextLink}
							target={link?.target}
							externalModalMessage={link?.externalModalMessage}>
							{button?.text || link?.text} {""}
							<Icon name="arrow-right" className={styles.noBorderTextLinkIcon} />
						</Link>
					)}
				</div>
			)}
		</div>
		{(button?.to || link?.to) && (
			<Link
				to={button?.to || link?.to}
				className={styles.noBorderLink}
				target={link?.target}
				externalModalMessage={link?.externalModalMessage}
				onOpenModal={link?.onOpenModal}>
				<span className="sr-only">{link?.text}</span>
			</Link>
		)}
	</Card>
);

NoBorderCard.propTypes = {
	image: PropTypes.shape({
		fluid: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		fixed: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		source: PropTypes.shape({
			src: PropTypes.string,
			srcSet: PropTypes.string,
			sizes: PropTypes.string,
		}),
		alt: PropTypes.string,
		src: PropTypes.string,
		srcSet: PropTypes.string,
	}).isRequired,
	header: PropTypes.string.isRequired,
	button: PropTypes.shape({
		icon: PropTypes.string,
		onClick: PropTypes.func,
		text: PropTypes.string,
		to: PropTypes.string,
	}),
	link: PropTypes.shape({
		icon: PropTypes.string,
		target: PropTypes.string,
		text: PropTypes.string,
		to: PropTypes.string,
		externalModalMessage: PropTypes.string,
		onOpenModal: PropTypes.func,
	}),
	hideLinks: PropTypes.bool,
	className: PropTypes.object,
	ribbon: PropTypes.string,
	subheader: PropTypes.string,
	color: PropTypes.oneOf(Object.keys(CardTabTheme)),
};

NoBorderCard.defaultProps = {
	button: null,
	link: null,
	hideLinks: false,
	className: {},
	ribbon: null,
	subheader: null,
	color: null,
};

export default NoBorderCard;
export { NoBorderCard, CardTabTheme };
